<template>
    <v-app
        id="inspire"
        v-if="loaded"
        style="max-width: 100vw; overflow: hidden;"
    >
        <side-menu/>

        <title-updater></title-updater>

        <top-menu/>

        <v-main>
<!--            <breadcrumbs></breadcrumbs>-->
            <router-view></router-view>
        </v-main>

        <filter-menu/>

        <!--        <copyright-footer/>-->

    </v-app>
</template>

<script>
    import SideMenu from './../common/SideMenu';
    import TopMenu from './../common/TopMenu';
    import TitleUpdater from '../functional/Title';
    import Breadcrumbs from '../functional/Breadcrumbs';
    import CopyrightFooter from './../common/Footer';
    import FilterMenu from './../common/FilterMenu';

    export default {
        data() {
            return {
                loaded: false,
            }
        },
        components: {
            SideMenu,
            TopMenu,
            Breadcrumbs,
            TitleUpdater,
            CopyrightFooter,
            FilterMenu
        },
        computed: {
            loggedInUser() {
                return this.$store.getters['auth/getUser'];
            }
        },
        name: 'Master',
        mounted() {
            if (!this.$store.getters['auth/isLoggedIn']) {
                this.$store.dispatch('auth/getUser')
                    .then(response => {
                        this.loaded = true;
                        this.$store.dispatch('auth/removePreloader');
                    })
                    .catch(error => {
                        if (error.response.status == 401) {
                            window.location = '/login';
                        }

                        console.error(error);
                    });
            } else {
                this.loaded = true;
                this.$store.dispatch('auth/removePreloader');
            }
        },
        methods: {}
    }
</script>
